module.exports = __webpack_public_path__ + "static/img/icon_footer_wechatmini.b36a626.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_footer_wechatmini.png
// module id = GX8G
// module chunks = 1